
import * as React from "react"

/**
 * Hook to detect Android devices
 * @returns boolean indicating if the device is an Android device
 */
export function useAndroidDetection() {
  const [isAndroid, setIsAndroid] = React.useState<boolean>(false)
  
  React.useEffect(() => {
    // Check if device is Android
    const checkIsAndroid = () => {
      if (typeof navigator === 'undefined') return false;
      
      const userAgent = navigator.userAgent || "";
      
      // Most reliable Android detection
      const isAndroidDevice = /Android/i.test(userAgent);
      
      // Additional check for Android browsers
      const isChromeMobile = /Chrome\/[.0-9]* Mobile/i.test(userAgent);
      const isSamsungBrowser = /SamsungBrowser/i.test(userAgent);
      
      // Some Android-specific features
      const hasAndroidTouchFeatures = 
        typeof window !== 'undefined' && 
        'ontouchstart' in window && 
        !(/iPhone|iPad|iPod/i.test(userAgent));
        
      setIsAndroid(
        isAndroidDevice || 
        (isChromeMobile && hasAndroidTouchFeatures) ||
        isSamsungBrowser
      );
    }
    
    checkIsAndroid();
    
    // This won't change during session but adding for completeness
    window.addEventListener('resize', checkIsAndroid);
    return () => window.removeEventListener('resize', checkIsAndroid);
  }, []);
  
  return isAndroid;
}
